$(function () {
  const previewLink = function (platform, val) {
    if (!val || (val && val === '')) {
      return '';
    } else if (val.includes('http')) {
      return val;
    } else {
      return `https://${platform}.com/${val}`
    }
  };

  $('[data-social-link-platform]').each((idx, element) => {
    const platform = element.dataset.socialLinkPlatform;
    const $el = $(element);
    const $textField = $el.find('input[type=text]');
    const $preview = $el.find('.preview-url');
    $preview.text(previewLink(platform, $textField.val()));
    $textField.on('keyup', el => {
      $preview.text(previewLink(platform, $textField.val()));
    })
  });
});